import Builder from '@/components/Builder';
import DataAccess from '@/components/data-access/DataAccess';
import DataAccessObjectsNav from '@/components/data-access/ObjectsNav';
import ObjectSettingsDataAccess from '@/components/objects/ObjectSettingsDataAccess';
import { getSharedObjectPaths } from '@/router/shared/SharedObjectPaths';

export default [
  {
    path: '/data-access',
    component: Builder,
    children: [
      {
        path: '',
        component: DataAccess,
        children: [
          {
            path: 'objects/:objectKey',
            components: {
              toolbox: DataAccessObjectsNav,
              body: ObjectSettingsDataAccess,
            },
            children: [

              // object settings
              ...getSharedObjectPaths(),
            ],
          },
        ],
      },
    ],
  },
];
